import React, { useEffect, useState } from 'react';
import '../../ApplicationsDashboard/ApplicationsDashboard.css';
import './LimitSanction.css';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../components/Sidebar/Sidebar';
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch,
    faBell,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { useDispatch, useSelector } from 'react-redux';
import { getLimitSanctionReport } from '../../../redux/ReportsReducer/action';
import DatePicker from 'react-datepicker';
import { downloadReport, downloadReportByDateRange, resetFilters } from '../../../utils/reportUtils';
import DownloadReport from '../DownloadReport';
import FilterModal from '../FilterModal/FilterModal';
import FunnelIconSvg from '../../../components/SVG/FunnelIconSvg';
import { isAuthorised } from '../../../utils/common';
import { REPORTS_COMPONENTS } from '../../../config/reports';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import { getAuthToken } from "../../../utils/auth";

const LimitSanctionReports = () => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    const { limitSanctionReport, pagination, officerProfile } = useSelector((store) => {
    return {
      limitSanctionReport: store.ReportsReducer.limitSanctionReport.data,
      pagination: store.ReportsReducer.limitSanctionReport.pagination,
      officerProfile: store.UserReducer.officerProfile
    }
  }, []);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
    
    const leads = [];

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const storedFilters = JSON.parse(sessionStorage.getItem('limitSanctionFilters')) || {};
    
    const [limitSanctionFilters, setLimitSanctionFilters] = useState({
        application_id: storedFilters?.application_id || "",
        customer_name: storedFilters?.customer_name || "",
        customer_id: storedFilters?.customer_id || "",
        loan_id: storedFilters?.loan_id || "",
        branch_name: storedFilters?.branch_name || "",
        sanction_by: storedFilters?.sanction_by || "",
        loan_creation_from: storedFilters?.loan_creation_from || "",
        loan_creation_to: storedFilters?.loan_creation_to || "",
        is_signed: storedFilters?.is_signed || null,
        global_search: storedFilters?.global_search || ""
    });

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('reportsCurrentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('reportsLimit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('reportsTotalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    const [dateRange, setDateRange] = useState([
        limitSanctionFilters?.created_from ? new Date(limitSanctionFilters.created_from) : null,
        limitSanctionFilters?.created_to ? new Date(limitSanctionFilters.created_to) : null,
    ]);

    const [startDate, endDate] = dateRange;

    useEffect(() => {
        dispatch(getLimitSanctionReport(currentPage, limit, limitSanctionFilters, null));

        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
        sessionStorage.setItem('limitSanctionFilters', JSON.stringify(limitSanctionFilters));
    // }, [dispatch, limit, currentPage, limitSanctionFilters]);
    }, [dispatch, limit, currentPage]);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem("limitSanctionFilters");
            sessionStorage.removeItem("reportsCurrentPage");
            sessionStorage.removeItem("reportsLimit");
            sessionStorage.removeItem("reportsTotalPages");
            sessionStorage.removeItem("reportsTotalCount");
        };
    }, []);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('reportsCurrentPage', pageToSet.toString());
    };

    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleDateRangeChange = (update) => {
        setDateRange(update);

        const [start, end] = update;

        const updatedFilters = {
            ...limitSanctionFilters,
            loan_creation_from: formatDate(start),
            loan_creation_to: formatDate(end),
        };

        setLimitSanctionFilters(updatedFilters);
        sessionStorage.setItem("limitSanctionFilters", JSON.stringify(updatedFilters));
    };

    const handleFilterChange = (e) => {
        let {name, value} = e.target;

        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...limitSanctionFilters,
            [name]: value
        };

        setLimitSanctionFilters(updatedFilters);
        sessionStorage.setItem("limitSanctionFilters", JSON.stringify(updatedFilters));
    }

    useEffect(() => {
        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
    }, [limit, currentPage]);

    return (
        <>
        <div className="reportsDashboardContainer">
            <div className="reportsDashboard">
                <Sidebar />

                <div className="dashboardMainContent">
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            {/* <div className="headerSearchBar">
                                <input type="text" placeholder="Search" />
                                <FontAwesomeIcon icon={faSearch} />
                            </div>
                            <div className="headerNotifications">
                                <FontAwesomeIcon icon={faBell} />
                                <span className="notificationBadge">9+</span>
                            </div>
                            <div className="headerHelp">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </div> */}
                            <UserProfileDropdown />
                        </div>
                    </div>

                    <div className="pageContentWrapper">
                        <div className="pageHeaderSection">
                        <Breadcrumb items={[
                            { label: 'Admin' },
                            { label: 'Reports', onClick: () => navigate('/reports') },
                            { label: 'Limit Sanction' }
                        ]} />

                        <div className="pageActions">
                            <h2>Limit Sanction</h2>
                        </div>
                    </div>

                   <div className="searchControlSection">
    <div className="searchGroup">
        {isAuthorised(
            officerProfile,
            REPORTS_COMPONENTS['limit-sanction_search']
        ) && <div className="tableSearchBar">
            <input 
                // type="text" 
                type="search" 
                placeholder="Search" 
                name="global_search"
                value={limitSanctionFilters?.global_search} 
                onChange={handleFilterChange}
                onInput={(e) => {
                    if (e.target.value === "") {
                        let updatedFilters = {
                            ...limitSanctionFilters,
                            global_search: e.target.value
                        }

                        setLimitSanctionFilters(updatedFilters)

                        dispatch(getLimitSanctionReport(1, limit, updatedFilters));
                        handlePageChange(1);
                    }
                }}
            />
            {/* <FontAwesomeIcon icon={faSearch} /> */}
        </div>}
        <div className="searchActionButtons">
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['limit-sanction_search']
            ) && <button 
                className="searchButton"
                onClick={() => {
                    dispatch(getLimitSanctionReport(1, limit, limitSanctionFilters, null));
                }}
            >
                 <FontAwesomeIcon icon={faSearch} />
            </button>}
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['limit-sanction_download']
            ) && <button 
                className="downloadButton"
                // onClick={() => downloadReportByDateRange("limit-sanction", limitSanctionFilters?.loan_creation_from, limitSanctionFilters?.loan_creation_to)}
                // onClick={() => setShowDownloadModal(true)}
                onClick={() => {
                    downloadReport("limit-sanction", limitSanctionFilters, setIsDownloading);
                }}
                disabled={isDownloading}
            >
                {isDownloading ? (
                    <>
                        <span className="buttonSpinner"></span>
                        Downloading...
                    </>
                ) : (
                    <>
                        Download
                    </>
                )}
            </button>}
            {isAuthorised(
                officerProfile,
                REPORTS_COMPONENTS['limit-sanction_filters']
            ) && (
                <div className="filterPopoverWrapper">
                    <button 
                        className="filterButton"
                        onClick={() => setShowFilterModal(!showFilterModal)}
                    >
                        <FunnelIconSvg fillColor={"black"}/>
                    </button>
                    {showFilterModal && (
                        <FilterModal 
                            reportTitle={"limit-sanction"}
                            filters={limitSanctionFilters}
                            setFilters={setLimitSanctionFilters}
                            resetFilters={() => {
                                let resettedFilters = resetFilters(limitSanctionFilters);

                                setLimitSanctionFilters(resettedFilters);
                                dispatch(getLimitSanctionReport(1, limit, resettedFilters, null));
                                handlePageChange(1);
                                setShowFilterModal(false);
                                sessionStorage.setItem("limitSanctionFilters", JSON.stringify(resettedFilters));
                                return resettedFilters;
                            }}
                            handleApplyFilters={(finalFilters) => {
                                handlePageChange(1);
                                dispatch(getLimitSanctionReport(1, limit, finalFilters, null));
                                setShowFilterModal(false);
                            }}
                            onClose={() => {
                                setShowFilterModal(false);
                            }}
                        />
                    )}
                </div>
            )}
        </div>
    </div>
</div>



                    <div className="tableCard">
                        <main className="">
                            <div className="reportsTableContainer">
                                <table className="applications-table" style={{ overflowX: "auto" }}>
                                <thead>
                                    <tr>
                                        <th>Application ID</th>
                                        <th>Branch</th>
                                        <th>Customer Name</th>
                                        <th>Customer ID</th>
                                        <th>Loan ID</th>
                                        <th>RO - Created</th>
                                        <th>RO - Assigned</th>
                                        <th>Amount Applied</th>
                                        <th>Amount Sanctioned</th>
                                        <th>Sanctioned By</th>
                                        <th>Loan Creation Date</th>
                                        <th>E-Sign Status (Y/N)</th>
                                        <th>E-Sign Date</th>
                                        <th>Processing Fee Amount</th>
                                        <th>Insurance Amount</th>
                                        <th>Customer Mobile No.</th>
                                        <th>RO - Assigned Contact No.</th>
                                    </tr>
                                    {/* <tr className="filter-row">
                                        <td>
                                            <input
                                                type="text"
                                                name="application_id"
                                                value={limitSanctionFilters?.application_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="branch_name"
                                                value={limitSanctionFilters?.branch_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_name"
                                                value={limitSanctionFilters?.customer_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_id"
                                                value={limitSanctionFilters?.customer_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="loan_id"
                                                value={limitSanctionFilters?.loan_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="sanction_by"
                                                value={limitSanctionFilters?.sanction_by || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <DatePicker
                                                selectsRange
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={handleDateRangeChange}
                                                isClearable
                                                placeholderText="Select date range"
                                                className="form-control form-control-sm date-picker-filter"
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="is_signed"
                                                value={limitSanctionFilters?.is_signed || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr> */}
                                </thead>
                                <tbody>
                                    {
                                        limitSanctionReport?.length === 0 ?
                                        <tr>
                                            <td colSpan={14} className="no-data-cell">
                                                No records found
                                            </td>
                                        </tr> :
                                        limitSanctionReport?.map((loan, index) => (
                                            <tr key={index}>
                                                <td>{loan?.application_id}</td>
                                                <td>{loan?.branch_name}</td>
                                                <td>{loan?.customer_name}</td>
                                                <td>{loan?.customer_id}</td>
                                                <td>{loan?.loan_id}</td>
                                                <td>{loan?.ro_created}</td>
                                                <td>{loan?.ro_assigned}</td>
                                                <td>{loan?.applied_amount}</td>
                                                <td>{loan?.sanction_amount}</td>
                                                <td>{loan?.sanction_by}</td>
                                                <td>{loan?.loan_creation_date?.split('T')?.[0]}</td>
                                                <td>{loan?.is_signed}</td>
                                                <td>{loan?.signed_date}</td>
                                                <td>{loan?.processing_fee_amount}</td>
                                                <td>{loan?.insurance_premium_amount}</td>
                                                <td>{loan?.customer_phone_number}</td>
                                                <td>{""}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>

                        {limitSanctionReport?.length > 0 && <div className="paginationControls">
                            <CustomPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>}
                        </main>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        {
            showDownloadModal && (
                <DownloadReport 
                    isOpen={showDownloadModal}
                    onClose={() => setShowDownloadModal(false)}
                    reportTitle={"limit-sanction"}
                />
            )
        }
        </>
    )
}

export default LimitSanctionReports